import { renderApp } from 'Renderapp';
const initApp = (document: Document) => {
    document.addEventListener('DOMContentLoaded', function () {
        renderApp(document);
    });
}
initApp(document);